import React, { useState , useEffect} from "react";
import cyclestyle from "../Styles/Cycles.css"
import axios from 'axios';
import { Buffer } from 'buffer';
import Loading from "./Loading";
const Cycles= () =>{
    const[data,setData] = useState([]);
    const[loading,setLoading] = useState(true);
    useEffect(()=>
    {
      
        axios.get('https://bechnaabackend.onrender.com/cycles')
        .then((res)=> setData(res.data))
        .catch((err)=> console.log(err,'thereeeeeeeeeeeee issssssssss proooooooooooblem'));
        
    });
    function handleLoad() {
        setLoading(false);
      }
      return (
        <>
        {loading && <Loading/>}
       <div className='row'>
          {
              data.map((item)=>
              {
                  let tdata = item.image.data.data;
                  const base64String = Buffer.from(tdata).toString('base64');
    
                  return <div className="column" key={item._id}>  
                              <img src={`data:image/png;base64,${base64String}`  } alt="cycle" onLoad={handleLoad}  />
                              <div className="prodetails">
                                   <p>Details: {item.name}</p>
                                   <p>Price: {item.price}/-</p>
                                   <button onClick={(e)=>{alert(item.phno)}}>Connect with Seller</button>
                              </div>
                           </div>
              })
          }
        </div>
        </>
      );
}

export default Cycles;